import { useTranslation } from "react-i18next";
import './loginError.scss';

interface ILoginErrorComponent {
    errMessage: string;
}

const LoginErrorComponent = (props: ILoginErrorComponent) =>  {
    const { t } = useTranslation('browser');

    return (
        <div className="login-error-component">
            <img src="/media/login-error.svg" className='login-error-icon' alt="login-error-icon" />
            <span className="login-error-message">{ t(`${props?.errMessage}`) }</span>
        </div>
    )
}

export default LoginErrorComponent;